<template>
    <v-container id="adminconsultas-cjg">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>CJG - ADMINISTRACIÓN DE CONSULTAS</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="listar"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Agregar Consulta"
                    @click="agregar"
                    :disabled="!permisoescritura"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    item-key="idconsulta"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            color="green"
                            @click="editar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || item.idestado===2"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            color="black"
                            @click="novedades(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || item.idestado===2"
                          >
                            <v-icon>mdi-playlist-edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Novedades</span>
                      </v-tooltip>
                      &nbsp;
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            x-small
                            icon
                            color="red"
                            @click="quitar(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura || item.idestado===2"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Anular</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.estado="{ item }">
                      <v-chip :color="getColorConsulta(item.idestado)" dark>
                        <p class="textofilagrilla">{{ item.estado }}</p>
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevo" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialognuevotitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardar">
                    Guardar
                </v-btn>
                <v-btn
                    color="red darken-1"
                    text
                    @click="dialognuevo = false"
                >
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="edited.idtipoconsulta"
                  :items="listatiposconsulta"
                  label="Tipo Consulta"
                  item-text="nombre"
                  item-value="idtipoconsulta"
                  height="20px"
                  v-on:change="selecionatipoconsulta()"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="edited.idmedioconsulta"
                  :items="listamediosconsulta"
                  label="Medio Consulta"
                  item-text="nombre"
                  item-value="idmedioconsulta"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-menu
                  v-model="menufechaconsulta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfcon"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="edited.fecha"
                    @input="menufechaconsulta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="edited.idtema"
                  :items="listatemas"
                  label="Tema"
                  item-text="nombre"
                  item-value="idtema"
                  height="20px"
                  v-on:change="selecionatema()"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <!-- <v-text-field
                  v-model="edited.observacion"
                  label="Obs."
                  height="20px"
                /> -->
                <v-select
                  v-model="edited.idsubtema"
                  :items="listasubtemas"
                  label="SubTema"
                  item-text="nombre"
                  item-value="idsubtema"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="5" lg="5">
                <v-text-field
                  v-model="apenompersonasel"
                  label="Persona"
                  height="20px"
                  readonly
                />
              </v-col>
              <v-col cols="12" md="1" lg="1">
                <v-btn color="primary" icon @click="abrepersonas">
                    <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
                <v-btn color="danger" icon @click="quitapersona">
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="edited.idabogado"
                  :items="listaabogados"
                  label="Abogado"
                  item-text="abogado"
                  item-value="idabogado"
                  height="20px"
                  :disabled="edited.idtipoconsulta===2"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-select
                  v-model="edited.idestado"
                  :items="listaestadosconsultas"
                  label="Estado"
                  item-text="nombre"
                  item-value="idestado"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogpersonas" fullscreen>
        <v-card>
          <v-card-title class="headline">
            Selecciona Persona
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="red darken-1" text @click="dialogpersonas = false">
                    Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="filtroper.nrodoc"
                  label="Documento"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="7" lg="7">
                <v-text-field
                  v-model="filtroper.apenom"
                  label="Apellido y Nombre"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="1" lg="1" class="alineacentro">
                <v-btn color="primary" icon @click="listarpersonas">
                    <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" md="1" lg="1" class="alineacentro">
                <v-btn color="green" icon @click="agregarpersona">
                    <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                  :headers="columnasper"
                  :items="listaper"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                  }"
                  item-key="idpersona"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            x-small
                            icon
                            color="blue"
                            @click="selpersona(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-arrow-right</v-icon>
                        </v-btn>
                      </template>
                      <span>Seleccionar</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            x-small
                            icon
                            color="green"
                            @click="editarpersona(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogabmper" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialogabmpertitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="grabarpersona">
                    Grabar
                </v-btn>
                <v-btn color="red darken-1" text @click="dialogabmper = false">
                    Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.apellido"
                  label="Apellido"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.nombre"
                  label="Nombre"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="editedper.idtipodoc"
                  :items="listatiposdoc"
                  label="Tipo Doc."
                  item-text="nombre"
                  item-value="idtipodoc"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.nrodoc"
                  label="Documento"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.nacionalidad"
                  label="Nacionalidad"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.ocupacion"
                  label="Ocupación"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="editedper.idestadocivil"
                  :items="listaestadosciviles"
                  label="Est. Civil"
                  item-text="nombre"
                  item-value="idestadocivil"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-menu
                  v-model="menufechanac"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfnac"
                      label="Fecha Nac."
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedper.fechanac"
                    @input="menufechanac = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="editedper.domicilioreal"
                  label="Domicilio Real"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <selector-localidadV2 ref="sellocreal" titulo="Localidad Real" :idinicial="editedper.idlocalidadreal" @selLocalidad="asignalocalidaddomicilioreal"></selector-localidadV2>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="editedper.domiciliolaboral"
                  label="Domicilio Laboral"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <selector-localidadV2 ref="selloclab" titulo="Localidad Laboral" :idinicial="editedper.idlocalidadlaboral" @selLocalidad="asignalocalidaddomiciliolaboral"></selector-localidadV2>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12" md="6" lg="6">
                <selector-localidadV2 ref="sellocnac" titulo="Localidad Nacimiento" :idinicial="editedper.idlocalidadnac" @selLocalidad="asignalocalidadnac"></selector-localidadV2>
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.telefono"
                  label="Teléfono"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-text-field
                  v-model="editedper.celular"
                  label="Celular"
                  height="20px"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialognovedades" persistent max-width="1024">
        <v-card>
          <v-card-title class="headline">
            {{dialognovedadestitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="red darken-1" text @click="dialognovedades = false">Cerrar</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  class="ma-2"
                  dark
                  x-small
                  color="primary"
                  title="Listar"
                  @click="listarnovedades"
                  :disabled="!permisolectura"
                >
                  <v-icon dark> mdi-magnify </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Agregar Novedad"
                  @click="agregarnovedad"
                  :disabled="!permisoescritura"
                >
                  <v-icon dark> mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                  :headers="columnasnov"
                  :items="listanovedades"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                  }"
                  item-key="idnovedad"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          color="green"
                          @click="editarnovedad(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!permisoescritura"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          x-small
                          icon
                          color="red"
                          @click="anularnovedad(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!permisoescritura"
                        >
                        <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <v-chip :color="getColorNovedad(item.idestado)" dark>
                      {{ item.estado }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogeditanovedad" fullscreen>
        <v-card>
          <v-card-title class="headline">
            {{dialogeditanovedadtitulo}}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="guardarnovedad">Guardar</v-btn>
                <v-btn color="red darken-1" text @click="dialogeditanovedad = false">Cerrar</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <br/>
            <br/>
            <v-row row wrap>
              <v-col cols="12" md="3" lg="3">
                <v-menu
                  v-model="menufechanovedad"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocalfnov"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editednov.fechanovedad"
                    @input="menufechanovedad = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6" lg="6">
                <v-select
                  v-model="editednov.idabogadoencargado"
                  :items="listaabogados"
                  label="Abogado Encargado"
                  item-text="abogado"
                  item-value="idabogado"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="editednov.idestado"
                  :items="listaestadosnovedades"
                  label="Estado"
                  item-text="nombre"
                  item-value="idestado"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-text-field
                  v-model="editednov.titulo"
                  label="Título"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-textarea
                  name="input-7-4"
                  label="Informe"
                  v-model="editednov.informe"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-file-input
                    v-model="files"
                    color="deep-purple accent-4"
                    counter
                    label="Seleccione Archivos Nuevos para Adjuntar"
                    multiple
                    placeholder="Seleccione Archivos"
                    prepend-icon="mdi-paperclip"
                    :show-size="1000"
                    height="20px"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2"
                        color="deep-purple accent-4"
                        dark
                        label
                        small
                    >
                      {{ text }}
                    </v-chip>
                    <span v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} Archivo(s)
                    </span>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
            <v-row row wrap>
              <v-col cols="12">
                <v-data-table
                    :headers="columnasarchivos"
                    :items="editednov.archivos"
                    hide-default-footer
                    item-key="idadjunto"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Archivos pre-existentes"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            @click="DescargaArchivo(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-file-download
                        </v-icon>
                      </template>
                      <span>Descarga Adjunto</span>
                    </v-tooltip>
                    &nbsp;
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            @click="QuitarArchivo(item)"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-delete
                        </v-icon>
                      </template>
                      <span>Borrar Adjunto</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorLocalidadV2 from "../../components/SelectorLocalidadV2.vue";
export default {
  name: "adminconsultas",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorLocalidadV2
  },
  data() {
    return {
      loading: false,
      usuario: "",
      permisolectura: false,
      permisoescritura: false,
      nromodulo: 58,
      dialogmensaje: false,
      mensajetitulo: "",
      mensajecuerpo: "",
      mensajehome: false,
      columnas: [
        {
            text: "Op.",
            value: "actions",
            width: 120
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idconsulta",
            width: 30
        },
        {
            text: "Fecha",
            align: "center",
            sortable: true,
            value: "fechadmy",
            width: 80
        },
        {
            text: "Tipo",
            align: "center",
            sortable: true,
            value: "tipoconsulta",
            width: 110
        },
        {
            text: "Medio",
            align: "center",
            sortable: true,
            value: "medioconsulta",
            width: 110
        },
        {
            text: "Tema",
            align: "center",
            sortable: true,
            value: "tema",
            width: 100
        },
        {
            text: "SubTema",
            align: "center",
            sortable: true,
            value: "subtema",
            width: 100
        },
        {
            text: "Consultor",
            align: "center",
            sortable: true,
            value: "persona",
            width: 120
        },
        {
            text: "Abo. Encargado",
            align: "center",
            sortable: true,
            value: "abogadoencargado",
            width: 120
        },
        {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 100
        }
      ],
      lista: [],
      dialognuevo: false,
      dialognuevotitulo: '',
      menufechaconsulta: false,
      edited: {
        idconsulta: 0,
        idtipoconsulta: 1,
        idmedioconsulta: 1,
        fecha: '',
        idtema: 0,
        idsubtema: 0,
        idpersona: 0,
        idabogado: 0,
        idestado: 0,
        usuario: ''
      },
      listapersonas: [],
      listaabogados: [],
      listatemas: [],
      listatemastodos: [],
      listasubtemas: [],
      listasubtemastodos: [],
      listaestadosconsultas: [],
      apenompersonasel: '',
      dialogpersonas: false,
      filtroper: {
        nrodoc: '',
        apenom: ''
      },
      columnasper: [
        {
            text: "Op.",
            value: "actions",
            width: 70
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idpersona",
            width: 30
        },
        {
            text: "Apellido",
            align: "center",
            sortable: true,
            value: "apellido",
            width: 100
        },
        {
            text: "Nombre",
            align: "center",
            sortable: true,
            value: "nombre",
            width: 100
        },
        {
            text: "Documento",
            align: "center",
            sortable: true,
            value: "nrodoc",
            width: 100
        },
        {
            text: "Ocupación",
            align: "center",
            sortable: true,
            value: "ocupacion",
            width: 100
        },
        {
            text: "Teléfono",
            align: "center",
            sortable: true,
            value: "telefono",
            width: 90
        },
        {
            text: "Celular",
            align: "center",
            sortable: true,
            value: "celular",
            width: 90
        }
      ],
      listaper: [],
      editedper: {
        idpersona: 0,
        apellido: '',
        nombre: '',
        idtipodoc: 2,
        nrodoc: '',
        nacionalidad: '',
        ocupacion: '',
        domicilioreal: '',
        domiciliolaboral: '',
        idlocalidadreal: 0,
        idlocalidadlaboral: 0,
        idestadocivil: 0,
        telefono: '',
        celular: '',
        fechanac: '',
        idlocalidadnac: 0,
        idestado: 0,
        usuario: ''
      },
      dialogabmper: false,
      dialogabmpertitulo: '',
      menufechanac: false,
      listaestadosciviles: [],
      listatiposdoc: [],
      dialogeditanovedad: false,
      dialogeditanovedadtitulo: '',
      menufechanovedad: false,
      editednov: {
        idnovedad: 0,
        idconsulta: 0,
        fechanovedad: '',
        idabogadoencargado: '',
        titulo: '',
        informe: '',
        idestado: 1,
        archivos: [],
        usuario: ''
      },
      dialognovedadestitulo: '',
      dialognovedades: false,
      columnasnov: [
        {
            text: "Op.",
            value: "actions",
            width: 120
        },
        {
            text: "ID",
            align: "center",
            sortable: true,
            value: "idnovedad",
            width: 30
        },
        {
            text: "Fecha",
            align: "center",
            sortable: true,
            value: "fechahoradmy",
            width: 110
        },
        {
            text: "Título",
            align: "center",
            sortable: true,
            value: "titulo",
            width: 150
        },
        {
            text: "Abogado",
            align: "center",
            sortable: true,
            value: "abogado",
            width: 120
        },
        {
            text: "Estado",
            align: "center",
            sortable: true,
            value: "estado",
            width: 90
        }
      ],
      listanovedades: [],
      columnasarchivos: [
        {
          text: "Op.",
          value: "actions",
          align: "center",
          width: 20,
        },
        {
          text: "Archivo",
          align: "left",
          sortable: true,
          value: "nombrearchivo",
          width: 250,
        },
      ],
      files: [],
      consultanov: 0,
      listaestadosnovedades: [],
      listatiposconsulta: [],
      listamediosconsulta: []
    };
  },
  mounted() {
    this.loading = true;
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    //var idrol = localStorage.getItem("rolusuario");
    var roles= localStorage.getItem('rolesusuario')
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion===1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
      this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
      this.cargacombos();
    }
  },
  methods: {
    cargacombos () {
      axios.get("referenciales/CJGtemas").then((result) => {
        this.listatemastodos = result.data[0];
        this.listasubtemastodos= result.data[1]
        axios.get("referenciales/CJGabogados").then((result) => {
          this.listaabogados = result.data;
          axios.get("referenciales/CJGestadosconsultas").then((result) => {
              this.listaestadosconsultas = result.data;
              var filtro= JSON.stringify({ idpersona: 0, apenom: '', nrodoc: '' });
              axios.post("cjg/PostListaPersonas", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
                if(result.data.resultado===0){
                  this.listapersonas = result.data.datos;
                  axios.get('tipodocumento').then((result) => {
                    this.listatiposdoc = result.data;
                    axios.get("referenciales/CJGestadosciviles").then((result) => {
                      this.listaestadosciviles = result.data;
                      axios.get("referenciales/CJestadonovedad").then((result) => {
                        this.listaestadosnovedades = result.data;
                        axios.get("referenciales/CJGtipoconsulta").then((result) => {
                          this.listatiposconsulta = result.data;
                          axios.get("referenciales/CJGmedioconsulta").then((result) => {
                            this.listamediosconsulta = result.data;
                            this.loading = false;
                          }).catch((error) => {
                            this.loading = false;
                            this.MostrarMensaje('Error', error, false);
                          })
                        }).catch((error) => {
                          this.loading = false;
                          this.MostrarMensaje('Error', error, false);
                        })
                      }).catch((error) => {
                        this.loading = false;
                        this.MostrarMensaje('Error', error, false);
                      })
                    }).catch((error) => {
                      this.loading = false;
                      this.MostrarMensaje('Error', error, false);
                    })
                  }).catch((error) => {
                    this.loading = false;
                    this.MostrarMensaje('Error', error, false);
                  })
                }else{
                  this.loading = false;
                  this.MostrarMensaje("Error", result.data.resultadomensaje, false);
                }
              }).catch((error) => {
                this.loading = false;
                this.MostrarMensaje("Error", error, false);
              });
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    listar () {
      this.loading=true;
      var filtro= JSON.stringify({idconsulta: 0, anio: 0, mes: 0, idtema: 0, idsubtema: 0, idpersona: 0, idestado: 0});
      axios.post("cjg/PostListaConsultas", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    agregar () {
      var fechaactual= new Date();
      this.listatemas= this.listatemastodos.filter(c=> c.validezhasta==null || (c.validezhasta!=null && new Date(c.validezhasta)>=fechaactual));
      this.listasubtemas=this.listasubtemastodos.filter(c=> c.idtema===this.listatemas[0].idtema && (c.validezhasta==null || (c.validezhasta!=null && new Date(c.validezhasta)>=fechaactual)));
      this.edited= {
        idconsulta: 0,
        idtipoconsulta: 1,
        idmedioconsulta: 1,
        fecha: this.fechaFormatoymd(new Date()),
        idtema: this.listatemas[0].idtema,
        idsubtema: 0,
        idpersona: '',
        idabogado: 0,
        idestado: 1,
        usuario: this.usuario
      };
      this.apenompersonasel='';
      this.edited.idsubtema= this.listasubtemas[0].idsubtema;
      this.dialognuevotitulo='Nueva Consulta';
      this.dialognuevo= true;
    },
    editar (item) {
      var fechaactual= new Date(item.fechahoraymd);
      this.listatemas= this.listatemastodos.filter(c=> c.validezhasta==null || (c.validezhasta!=null && new Date(c.validezhasta)>=fechaactual));
      this.listasubtemas=this.listasubtemastodos.filter(c=> c.idtema===item.idtema && (c.validezhasta==null || (c.validezhasta!=null && new Date(c.validezhasta)>=fechaactual)));
      this.edited= {
        idconsulta: item.idconsulta,
        idtipoconsulta: item.idtipoconsulta,
        idmedioconsulta: item.idmedioconsulta,
        fecha: item.fechaymd,
        idtema: item.idtema,
        idsubtema: item.idsubtema,
        idpersona: item.idpersona,
        idabogado: item.idabogadoencargado,
        idestado: item.idestado,
        usuario: this.usuario
      };
      this.apenompersonasel=item.persona;
      this.dialognuevotitulo='Editando Consulta N° ' + item.idconsulta;
      this.dialognuevo= true;
    },
    novedades (item) {
      this.dialognovedadestitulo='Novedades de la Consulta ' + item.idconsulta;
      this.consultanov= item.idconsulta;
      this.dialognovedades=true;
      this.listarnovedades();
    },
    async quitar (item) {
      if (await this.$refs.confirm.open("Confirmar Anulación","Esta seguro de querer anular la consulta ID " + item.idconsulta.toString() + " ?")) {
        this.loading= true;
        const cons = JSON.stringify({idconsulta: item.idconsulta, usuario: this.usuario});
        axios.post("cjg/PostAnularConsulta", cons, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.listar();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    guardar () {
      var valido='';
      if(this.edited.idpersona===null || this.edited.idpersona===''){
        valido='Debe seleccionar persona';
      }
      if(this.edited.idtipoconsulta===1 && (this.edited.idabogado===null || this.edited.idabogado==='' || this.edited.idabogado===0)){
        valido='Si la consulta es CON patrocinio debe seleccionar abogado';
      }
      if(valido.length===0){
        this.loading= true;
        const cons = JSON.stringify(this.edited);
        axios.post("cjg/PostConsulta", cons, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialognuevo = false;
            this.listar();
          } else {
            this.loading = false;
            var errordevuelto= result.data.resultadomensaje!= null ? result.data.resultadomensaje : 'Error al grabar consulta';
            this.MostrarMensaje("Error", errordevuelto, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.loading = false;
        this.MostrarMensaje("Error", valido, false);
      }
    },
    fechaFormatoymd(date) {
      return ( date.getFullYear() +"-" +((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate())
      );
    },
    selecionatema () {
      var fechaactual= new Date();
      if(this.edited.idconsulta>0) {
        fechaactual= new Date(this.edited.fecha);
      }
      this.listasubtemas = this.listasubtemastodos.filter(c=> c.idtema===this.edited.idtema && (c.validezhasta==null || (c.validezhasta!=null && new Date(c.validezhasta)>=fechaactual)));
      //this.listasubtemas=this.listasubtemastodos.filter(c=> c.idtema===this.edited.idtema);
      this.edited.idsubtema= this.listasubtemas[0].idsubtema;
    },
    abrepersonas () {
      this.dialogpersonas=true;
    },
    quitapersona () {
      this.apenompersonasel= '';
      this.edited.idpersona= 0;
    },
    listarpersonas () {
      this.loading=true;
      var an= this.filtroper.apenom!=null ? this.filtroper.apenom : '';
      var doc= this.filtroper.nrodoc!=null ? this.filtroper.nrodoc : '';
      var filtro= JSON.stringify({ idpersona: 0, apenom: an, nrodoc: doc });
      axios.post("cjg/PostListaPersonas", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listaper = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    agregarpersona () {
      if (this.$refs.sellocreal != null) {
        this.$refs.sellocreal.QuitarRegistro();
      }
      if (this.$refs.selloclab != null) {
        this.$refs.selloclab.QuitarRegistro();
      }
      if (this.$refs.sellocnac != null) {
        this.$refs.sellocnac.QuitarRegistro();
      }
      this.editedper= {
        idpersona: 0,
        apellido: '',
        nombre: '',
        idtipodoc: 2,
        nrodoc: '',
        nacionalidad: '',
        ocupacion: '',
        domicilioreal: '',
        domiciliolaboral: '',
        idlocalidadreal: 0,
        idlocalidadlaboral: 0,
        idestadocivil: 1,
        telefono: '',
        celular: '',
        fechanac: '',
        idlocalidadnac: 0,
        idestado: 1,
        usuario: this.usuario
      };
      this.dialogabmpertitulo= 'Nueva Persona';
      this.dialogabmper= true;
    },
    grabarpersona () {
      var valido='';
      valido= this.validarpersona();
      if(valido.length===0) {
        this.loading= true;
        const persona = JSON.stringify(this.editedper);
        axios.post("cjg/PostPersona", persona, { headers: { "Content-Type": "application/json" },}).then((result) => {
          if (result.data.resultado === 0) {
            this.dialogabmper = false;
            this.listarpersonas();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }else{
        this.loading = false;
        this.MostrarMensaje("Error", valido, false);
      }
    },
    validarpersona () {
      var valido='';
      if(this.editedper.apellido===null || this.editedper.apellido.length===0){
        valido='Debe ingresar Apellido de la persona';
      }
      if(this.editedper.nombre===null || this.editedper.nombre.length===0){
        valido='Debe ingresar Nombre de la persona';
      }
      if(this.editedper.nrodoc===null || this.editedper.nrodoc.length===0){
        valido='Debe ingresar Documento de la persona';
      }
      if(this.editedper.nrodoc===null || this.editedper.nrodoc.length===0){
        valido='Debe ingresar Documento de la persona';
      }
      return valido;
    },
    selpersona (value) {
      this.edited.idpersona= value.idpersona;
      this.apenompersonasel= value.apellido + ' ' + value.nombre;
      this.dialogpersonas= false;
    },
    editarpersona (item) {
      if (this.$refs.sellocreal != null) {
        this.$refs.sellocreal.QuitarRegistro();
      }
      if (this.$refs.selloclab != null) {
        this.$refs.selloclab.QuitarRegistro();
      }
      if (this.$refs.sellocnac != null) {
        this.$refs.sellocnac.QuitarRegistro();
      }
      this.editedper= {
        idpersona: item.idpersona,
        apellido: item.apellido,
        nombre: item.nombre,
        idtipodoc: item.idtipodoc,
        nrodoc: item.nrodoc,
        nacionalidad: item.nacionalidad,
        ocupacion: item.ocupacion,
        domicilioreal: item.domicilioreal,
        domiciliolaboral: item.domiciliolaboral,
        idlocalidadreal: item.idlocalidadreal,
        idlocalidadlaboral: item.idlocalidadlaboral,
        idestadocivil: item.idestadocivil,
        telefono: item.telefono,
        celular: item.celular,
        fechanac: item.fechanacymd,
        idlocalidadnac: item.idlocalidadnac,
        idestado: item.idestado,
        usuario: this.usuario
      };
      if(this.$refs.sellocreal!=null && this.editedper.idlocalidadreal!=null){
        this.$refs.sellocreal.idinicial= this.editedper.idlocalidadreal;
        this.$refs.sellocreal.BuscarRegistro();
      }
      if(this.$refs.selloclab!=null && this.editedper.idlocalidadlaboral!=null){
        this.$refs.selloclab.idinicial= this.editedper.idlocalidadlaboral;
        this.$refs.selloclab.BuscarRegistro();
      }
      if(this.$refs.sellocnac!=null && this.editedper.idlocalidadnac!=null){
        this.$refs.sellocnac.idinicial= this.editedper.idlocalidadnac;
        this.$refs.sellocnac.BuscarRegistro();
      }
      this.dialogabmpertitulo= 'Editando Persona ' + item.idpersona.toString()+' - '+item.apellido+' '+item.nombre;
      this.dialogabmper= true;
    },
    asignalocalidaddomicilioreal (value) {
      this.editedper.idlocalidadreal= value!=null ? value.idlocalidad : '';
    },
    asignalocalidaddomiciliolaboral (value) {
      this.editedper.idlocalidadlaboral= value!=null ? value.idlocalidad : '';
    },
    asignalocalidadnac (value) {
      this.editedper.idlocalidadnac= value!=null ? value.idlocalidad : '';
    },
    listarnovedades () {
      this.loading=true;
      var filtro= JSON.stringify({idconsulta: this.consultanov, usuario: this.usuario});
      axios.post("cjg/PostListaNovedadesxConsulta", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.listanovedades = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    agregarnovedad () {
      this.loading=true;
      this.files=[];
      this.editednov= {
        idnovedad: 0,
        idconsulta: this.consultanov,
        fechanovedad: this.fechaFormatoymd(new Date()),
        idabogadoencargado: 0,
        titulo: '',
        informe: '',
        idestado: 1,
        archivos: [],
        usuario: this.usuario
      };
      this.dialogeditanovedad=true;
      this.loading=false;
    },
    guardarnovedad () {
      var valido = "";
      if (this.editednov.fechanovedad === null || this.editednov.fechanovedad === '') {
        valido = "Debe ingresar la fecha de la novedad";
      }
      if (this.editednov.titulo.length === 0) {
        valido = "Debe ingresar el título de la novedad";
      }
      if (this.editednov.informe.length === 0) {
        valido = "Debe ingresar el informe de la novedad";
      }
      if (valido.length === 0) {
        this.loading = true;
        if (this.files.length > 0) {
          let files = new FormData();
          for (var i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            files.append("files", file);
          }
          axios.post("cjg/PostNovedadArchivos", files, {headers: {"content-type": "multipart/form-data"}}).then((result) => {
            if (result.data.resultado === 0) {
              this.GuardarNov(result.data.archivos);
            } else {
              this.loading = false;
              this.MostrarMensaje("Error",result.data.resultadoMensaje,false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        } else {
          this.GuardarNov(null);
        }
      } else {
        this.MostrarMensaje("Error", valido, false);
      }
    },
    GuardarNov(archivos) {
      if (archivos != null) {
        for (var i = 0; i < archivos.length; i++) {
          var reg = archivos[i];
          this.editednov.archivos.push({
            idnovedad: reg.idnovedad,
            idadjunto: reg.idadjunto,
            orden: reg.orden,
            nombrearchivo: reg.nombrearchivo,
            url: reg.url,
            urlweb: reg.urlweb,
          });
        }
      }
      const nov = JSON.stringify(this.editednov);
      axios.post("cjg/PostNovedad", nov, { headers: { "Content-Type": "application/json" },}).then((result) => {
        if (result.data.resultado === 0) {
          this.dialogeditanovedad = false;
          this.listarnovedades();
        } else {
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    editarnovedad (item) {
      this.loading=true;
      this.files=[];
      this.editednov= {
        idnovedad: item.idnovedad,
        idconsulta: this.consultanov,
        fechanovedad: item.fechahoraymd,
        idabogadoencargado: item.idabogadoencargado,
        titulo: item.titulo,
        informe: item.informe,
        idestado: item.idestado,
        archivos: item.adjuntos,
        usuario: this.usuario
      };
      this.dialogeditanovedad=true;
      this.loading=false;
    },
    async anularnovedad (item) {
      if(await this.$refs.confirm.open("Confirmar Anulación","Esta seguro de querer anular la novedad ID " +item.idnovedad.toString()+" ?")) {
        this.loading = true;
        var nov = { idnovedad: item.idnovedad, usuario: this.usuario };
        axios.post("cjg/PostAnularNovedad", nov, { headers: {"Content-Type": "application/json"}}).then((result) => {
          if (result.data.resultado === 0) {
            this.listarnovedades();
          } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    async QuitarArchivo(item) {
      if (await this.$refs.confirm.open("Confirmar Borrado de Archivo","Esta seguro de querer quitar el archivo de la novedad?")) {
        this.editednov.archivos.splice(this.editednov.archivos.indexOf(item), 1);
      }
    },
    getColorConsulta(idestado) {
      if (idestado === 1) return "green";
      else if (idestado === 2) return "red";
      else if (idestado === 3) return "blue";
    },
    getColorNovedad(idestado) {
      if (idestado === 1) return "green";
      else if (idestado === 2) return "red";
    },
    DescargaArchivo(item) {
      window.open(item.urlweb, "_blank");
    },
    selecionatipoconsulta () {
      /* if(this.edited.idtipoconsulta===1) {
        this.edited.idabogado=0;
      }else{
        this.edited.idabogado=0;
      } */
      this.edited.idabogado=0;
    }
},
  computed: {
    fechalocalfcon: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfnac: function () {
      if (this.editedper.fechanac != null && this.editedper.fechanac != "") {
        var fecha = new Date(this.editedper.fechanac);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
    fechalocalfnov: function () {
      if (this.editednov.fechanovedad != null && this.editednov.fechanovedad != "") {
        var fecha = new Date(this.editednov.fechanovedad);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>
/*.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}*/

.hide-toolbar .ql-toolbar {
    padding: 0;
    border-bottom: hidden;
    span {
        display: none;
    }
}

.ql-font-roboto {
  font-family: 'Roboto', sans-serif;
}

.editor {
    height: 40rem;
    overflow: hidden;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa10 {
  width: 10%;
}
.ocupa20 {
  width: 20%;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>